import { NetworkState } from './lib/NetworkState';
import { makeAutoObservable } from 'mobx';
import { MappingState } from './standard/MappingState';
import { EthNetworkConfig } from '../config/NetworkConfig';
import { ChainState } from './lib/ChainState';
import { EthNetworkState } from './lib/EthNetworkState';
import { RootStore } from './root';
import { NumberState } from './standard/base';
import { ValueOf } from 'type-fest';
import { eventBus } from '../lib/event';
import { helper } from '@/lib/helper';
import { fromBytes } from '@iotexproject/iotex-address-ts';

export enum Network {
  ETH = 'eth',
  BSC = 'bsc',
  IOTEX = 'iotex',
  POLYGON = 'polygon'
}
export type DisplayAddressType = '0x'|'io';
export class GodStore {
  rootStore: RootStore;
  network: MappingState<NetworkState> = new MappingState({
    currentId: 'eth',
    map: {
      eth: EthNetworkConfig
    }
  });

  updateTicker = new NumberState();

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {
      rootStore: false
    });
    EthNetworkConfig.god = this;
  }
  displayAddressType:DisplayAddressType='0x'

  get isIotxNetork() {
    return this.network.currentId.value == 'iotex';
  }
  get isETHNetwork() {
    //@ts-ignore
    return ['eth', 'bsc'].includes(this.network.currentId.value);
  }

  get eth(): EthNetworkState {
    return this.network.map.eth as EthNetworkState;
  }

  get isConnect() {
    return !!this.currentNetwork.account;
  }

  get currentNetwork() {
    return this.network.current;
  }

  get currentChain(): ChainState {
    return this.currentNetwork.currentChain;
  }

  get Coin() {
    return this.currentChain.Coin;
  }

  async loadBalance() {
    this.currentNetwork.loadBalance();
  }

  setNetwork(val: Network) {
    this.network.setCurrentId(val);
  }
  setChain(val: number) {
    this.currentNetwork.chain.setCurrentId(val);
    eventBus.emit('chain.switch');
  }
  setShowConnecter(value: boolean) {
    this.eth.connector.showConnector = value;
  }
  setDisplayAddressType(value:DisplayAddressType){
    this.displayAddressType = value
  }

  get accountIoAddress(){
    return fromBytes(Buffer.from(String(this.currentNetwork.account).replace(/^0x/, ''), 'hex')).string()
  }
}
